/**
 * Universal Section Animation Logic
 */

document.addEventListener("DOMContentLoaded", () => {
	// Ensure GSAP is loaded
	if (typeof gsap === "undefined") {
		console.warn("GSAP not found. Universal Section animation skipped.");
		return;
	}

	gsap.registerPlugin(ScrollTrigger);

	// 1. Standard Mode Animations
	const standardSections = document.querySelectorAll('.osmerova-uni-section[data-gsap="uni-standard"]');
	standardSections.forEach((section) => {
		let ctx = gsap.context(() => {
			const content = section.querySelector('.osmerova-uni-content-narrow');
			if (content && content.children.length > 0) {
				gsap.from(content.children, {
					y: 30,
					opacity: 0,
					duration: 0.8,
					stagger: 0.1,
					ease: "power2.out",
					scrollTrigger: {
						trigger: section,
						start: "top 75%"
					}
				});
			}
		}, section);
	});

	// 2. Hero Mode Animations
	const heroSections = document.querySelectorAll('.osmerova-uni-section[data-gsap="uni-hero"]');
	heroSections.forEach((section) => {
		let ctx = gsap.context(() => {
			
			// Parallax Background
			const bgImage = section.querySelector('.uni-hero-bg');
			if (bgImage) {
				gsap.to(bgImage, {
					yPercent: 15,
					ease: "none",
					scrollTrigger: {
						trigger: section,
						scrub: true,
						start: "top bottom",
						end: "bottom top"
					}
				});
			}

			// Content Reveal
			const content = section.querySelector('.osmerova-uni-content-center');
			if (content) {
				gsap.from(content, {
					y: 50,
					opacity: 0,
					duration: 1,
					ease: "power2.out",
					scrollTrigger: {
						trigger: section,
						start: "top 60%"
					}
				});
			}

		}, section);
	});
});
